import { SuccessIcon, WarningIcon } from "components/atoms/Icon";
import Tooltip from "components/atoms/Tooltip";
import { Paragraph } from "components/atoms/Typography";

interface PlanDropDownViewProps {
    displayName: string;
    isPublished: boolean;
    isOutdated: boolean;
}

function PlanDropDownView({ displayName, isPublished, isOutdated }: PlanDropDownViewProps) {
    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
            }}
        >
            {isOutdated && (
                <Tooltip tooltipBody="The base building state has changed since this plan was generated. Please remodel the plan so that it reflects the current building state.">
                    <WarningIcon
                        style={{
                            width: "17px",
                        }}
                    />
                </Tooltip>
            )}
            <Paragraph size="small">{displayName}</Paragraph>
            {isPublished && (
                <Tooltip tooltipBody="This plan is currently being published to 'My Plans'.">
                    <SuccessIcon
                        style={{
                            width: "7px",
                        }}
                    />
                </Tooltip>
            )}
        </div>
    );
}

export default PlanDropDownView;
